module Meevo.Plugins.DashboardGoals {

    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;

    interface IGoalValidation {
        maxValue: number;
        inputType: GoalInputTypeEnum;
    }

    class MeevoDashboardGoalsDataViewComponent implements angular.IComponentController {
        static $inject = [
            '$scope',
            '$translate',
            '$locale'
        ];
        public dataView: GoalInputTypeEnum;

        public goalsModel: IDashboardGoalModel;
        public selectedYear: number;
        public globalSelectedDateRange: GoalDateRangeEnum;
        public goalCategoryEnum = GoalCategoryEnum;
        public productivityModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public averageTicketModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public salesModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public frequencyOfVisitModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public rebookModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public newClientModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public fiveStarRatingModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public requestRateModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public retentionModel: _.Dictionary<IDashboardGoalColumn[]> = {};
        public membershipModel: _.Dictionary<IDashboardGoalColumn[]> = {};

        public measurement: number;
        public typeOfSale;
        public isMeasurementAmount: boolean = true;
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;

        public _measurementSelect = [
            {
                id: GoalInputTypeEnum.Currency,
                label: this.$translate.instant('LABEL_CURRENCY_AMOUNT', {currencySymbol: this.currencySymbol})
            },
            {
                id: GoalInputTypeEnum.Numeric,
                label: 'LABEL_UNITS'
            },
        ];
        public _typeOfSales = [
            {
                id: GoalCategoryEnum.Service,
                label: 'LABEL_SERVICE'
            },
            {
                id: GoalCategoryEnum.Retail,
                label: 'LABEL_RETAIL'
            },
            {
                id: GoalCategoryEnum.GiftCard,
                label: 'LABEL_GIFT_CARD'
            },
        ];

        public dateRanges = {
            ...DATE_RANGES
        };

        public averageTicketValidation: IGoalValidation;
        public salesValidation: IGoalValidation;
        public frequencyValidation: IGoalValidation;
        public rebookValidation: IGoalValidation;
        public newClientValidation: IGoalValidation;
        public fiveStarRatingValidation: IGoalValidation;
        public requestRateValidation: IGoalValidation;
        public retentionValidation: IGoalValidation;
        public membershipValidation: IGoalValidation;
        public productivityValidation: IGoalValidation;

        get goalInputTypeEnum() {
            return GoalInputTypeEnum;
        }

        constructor(
            private $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            private $locale: angular.ILocaleService
        ) {
            this.dataView = GoalInputTypeEnum.Currency; // TODO: change inputType

            this.averageTicketValidation = {
                maxValue: 9999900,
                inputType: GoalInputTypeEnum.Currency
            };
            this.salesValidation = {
                maxValue: 9999900,
                inputType: this.measurement
            };
            this.frequencyValidation = {
                maxValue: 9999900,
                inputType: GoalInputTypeEnum.Numeric
            };
            this.rebookValidation = {
                maxValue: 100,
                inputType: GoalInputTypeEnum.Percentage
            };

            this.newClientValidation = {
                maxValue: 9999900,
                inputType: GoalInputTypeEnum.Float
            };
            this.fiveStarRatingValidation = {
                maxValue: 5,
                inputType: GoalInputTypeEnum.Float
            };
            this.requestRateValidation = {
                maxValue: 100,
                inputType: GoalInputTypeEnum.Percentage
            };
            this.retentionValidation = {
                maxValue: 100,
                inputType: GoalInputTypeEnum.Percentage
            };
            this.productivityValidation = {
                maxValue: 100,
                inputType: GoalInputTypeEnum.Percentage
            };
            this.membershipValidation = {
                maxValue: 9999900,
                inputType: GoalInputTypeEnum.Numeric
            };
        }

        $onInit() {
            this.$scope.$watch(() => this.goalsModel, (value) => {
                this.initData();
                
            }, true);
        }

        public initData(): void {
            if (this.goalsModel) {

                this.productivityModel = this.formatGoals(this.goalsModel.productivity);
                this.averageTicketModel = this.formatGoals(this.goalsModel.averageTicket);
                this.frequencyOfVisitModel = this.formatGoals(this.goalsModel.frequencyOfVisit);
                this.rebookModel = this.formatGoals(this.goalsModel.rebook);
                this.salesModel = this.formatGoals(this.goalsModel.sales);
                this.newClientModel = this.formatGoals(this.goalsModel.newClient);
                this.fiveStarRatingModel = this.formatGoals(this.goalsModel.fiveStarRating);
                this.requestRateModel = this.formatGoals(this.goalsModel.requestRate);
                this.retentionModel = this.formatGoals(this.goalsModel.retention);
                this.membershipModel = this.formatGoals(this.goalsModel.membership);
            }
        }

        public formatGoals(list: Array<IDashboardGoalColumn>): _.Dictionary<IDashboardGoalColumn[]> {
            if (!list) return;

            let currentYear: number = new Date().getFullYear();
            let formattedGoal = _.groupBy<IDashboardGoalColumn>(list, 'dateRangeEnum');
            let isCurrentYearSelected = this.selectedYear == currentYear;
            

            if (isCurrentYearSelected && list != this.goalsModel.retention && list != this.goalsModel.frequencyOfVisit) {
                delete formattedGoal['0'];
            }
            return formattedGoal;
        }

        public changeMeasurement(): void {
            this.isMeasurementAmount = this.measurement === GoalInputTypeEnum.Currency;

            this.salesValidation.inputType = this.measurement;
        }

        public filterByGoalsCategory(goal: IDashboardGoalColumn): boolean {
            return (goal.dateRangeEnum !== GoalDateRangeEnum.YearToDate && goal.dateRangeEnum !== GoalDateRangeEnum.LastTwelveMonths) || ((goal.dateRangeEnum === GoalDateRangeEnum.YearToDate || goal.dateRangeEnum === GoalDateRangeEnum.LastTwelveMonths) && goal.month === 0);
        }
    }


    angular.module('meevo.plugins.dashboardGoals')
        .component('meevoDashboardGoalsDataViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/dashboardGoals/components/dataView/dataView.component.html',
            controller: MeevoDashboardGoalsDataViewComponent,
            controllerAs: '$ctrl',
            bindings: {
                goalsModel: '<',
                globalSelectedDateRange: '=',
                selectedYear: '='
            }
        });

}
